
import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { EnrollmentEvent, EnrollmentEventType } from '@/services/db/enrollment/types';
import { EnrollmentEventItem } from './EnrollmentEventItem';

interface EnrollmentEventsListProps {
  events: EnrollmentEvent[];
  filter?: EnrollmentEventType[];
}

export const EnrollmentEventsList: React.FC<EnrollmentEventsListProps> = ({ events, filter }) => {
  const filteredEvents = filter 
    ? events.filter(e => filter.includes(e.eventType))
    : events;

  return (
    <ScrollArea className="h-[400px] overflow-hidden">
      <div className="space-y-4">
        {filteredEvents.map((event) => (
          <EnrollmentEventItem key={event.id} event={event} />
        ))}
      </div>
    </ScrollArea>
  );
};
